export default "__VITE_ASSET__BUAU7TeX__"